import { Component, OnInit } from "@angular/core";
import { WalletService } from "../services/wallet.service";
import { TimerService } from "../services/timer.service";
import { Tabs } from "./tabs";
import { NbDialogService, NbToastrService } from "@nebular/theme";
import { ApiService } from "../services/api.service";
import { WalletConnectDialogComponent } from "../wallet-connect-dialog/wallet-connect-dialog.component";
import * as listener from "../../scripts/listener.js";

@Component({
    selector: "ngx-contribution",
    templateUrl: "./contribution.component.html",
    styleUrls: ["./contribution.component.scss"],
})
export class ContributionComponent implements OnInit {
    // Condition for when wallet is conected - Bool takes care of disabling buttons and hiding sale starts in and replacing it.
    // Can use methods below to check if wallet is connected
    isConnected = false;
    tabs = Tabs;
    currentUserAddress;
    isMetamask = false;
    isWalletConnect = false;
    private currentUserAddres: any = "";
    private totalAmountBacked;
    private tokenName = "Litbit";
    public userBalance = 0;
    userContribAmount: any = 0;
    currentAddress;
    private userId;
    projectType: string;
    projectEnded: string;
    buttonColor: string;
    currentCrowdsale: number;
    contributionRules: any;
    timeEnd;
    tokenPrice;
    public saleStartPercentage: any;
    public stageActive: boolean | string;
    public availableAmountPercentage: any;
    constructor(
        public _timerService: TimerService,
        public _walletService: WalletService,
        public _apiService: ApiService,
        public nbDialogService: NbDialogService
    ) {}
    openDialog() {
        this.nbDialogService.open(WalletConnectDialogComponent, {
            context: {},
        });
    }
    ngOnInit() {
        this.getStageRules();
        this.getContributionData();
        this.getContributionAmountPerUser();
        this.currentUserAddres = this.checkConnectionAddress();
        this.checkwalletConnection();
        this._walletService.checkWalletDisconnect();
        // this._timerService.getTime();
        this.getStageDetails();
    }
    ngAfterViewInit() {
        this.getUserBalance();
    }

    isStageActive(startTime, endTime) {
        let currentTime = Date.now();
        if (
            startTime * 1000 - currentTime < 0 &&
            endTime * 1000 - currentTime < 0
        ) {
            // previously active
            return false;
        } else if (
            startTime * 1000 - currentTime < 0 &&
            endTime * 1000 - currentTime > 0
        ) {
            // currently active
            this.saleStartPercentage =
                ((currentTime - startTime * 1000) /
                    (endTime * 1000 - startTime * 1000)) *
                100;

            return true;
        } else {
            // future
            return false;
        }
    }

    getStageRules() {
        this._apiService.getStageRules(1).subscribe((res) => {
            this.availableAmountPercentage =
                (res["stageRules"]["totalSupply"] /
                    res["stageRules"]["assumedInitialMarketCap"]) *
                100;
            this.stageActive = this.isStageActive(
                res["startTime"],
                res["endTime"]
            );
        });
    }

    getStageRulesWithStageInfo = async (currentCrowdsale) => {
        this._apiService.getStageRules(currentCrowdsale).subscribe((res) => {
            let contribDetails = res;
            console.log(res);
        });
    };
    getContributionData() {
        this._apiService
            .getStageRules(1) // Currently 1, will recive from db
            .subscribe((res) => {
                this.contributionRules = res;
            });
    }
    getProjectDetails = async () => {
        this._apiService.getProjectData(0).subscribe(
            (res) => {
                this.projectType = res["data"][0]["attributes"]["ProjectType"];
                let dateToday = Date.parse(new Date().toString());
                let dateStart = Date.parse(
                    res["data"][0]["attributes"]["DateStarted"]
                );
                let dateEnd = Date.parse(
                    res["data"][0]["attributes"]["DateEnded"]
                );
                console.log(dateToday);
                console.log(dateStart);
                console.log(dateEnd);

                if (dateToday > dateStart && dateToday < dateEnd) {
                    this.projectEnded = "Ongoing";
                    this.buttonColor = "Green";
                } else if (dateToday < dateStart) {
                    this.projectEnded = "Not started yet";
                    this.buttonColor = "Red";
                } else if (dateToday > dateEnd) {
                    this.projectEnded = "Ended";
                    this.buttonColor = "Red";
                } else {
                    this.projectEnded = "Ended";
                    this.buttonColor = "Red";
                }
            },
            (err) => {
                console.log(err);
            }
        );
    };
    getStageDetails = async () => {
        this._apiService.getStageRules(1).subscribe(async (res) => {
            this.tokenPrice = res["price"];
        });
    };
    /**
     * Get amount of tokens that are alredy backed, and this should call the public stage
     */
    getContributionAmountPerUser = async () => {
        this.userContribAmount = 0;
        this.currentAddress = await this._walletService.getAddress();
        if (Array.isArray(this.currentUserAddress)) {
            this.currentUserAddress = this.currentUserAddress[0];
        }
        let sum: any;
        let contributionAmount = this._apiService
            .getSumPerActiveStage(1)
            .subscribe(async (res) => {
                this.userContribAmount = res["totalAmount"];
            });
    };
    getUserBalance() {
        let userData;
        // this._apiService.getUserBalance("?filters[address][$eq]="+this.currentUserAddres).subscribe((res)=> {
        //   this.userBalance= res['data'][0]['attributes']['Balance']
        //   this.userId = res['data'][0]['id']
        // });
    }
    /**
     * Buy tokens, fetch from some form
     * Save the amount of tokens user had bought
     * Update contribution-token table, set totalAmountBackend equal to current+user bought.
     */
    buyTokens() {
        // this._walletService.buyTokens(this.currentUserAddres, amount);
        let tokenAmount = 10; // Check how token amount will be entered
        let totalAvailable =
            this.totalAmountBacked[0]["attributes"].totalAvailable; // Amount of tokens that have alredy been bougt
        let tokenContribId = this.totalAmountBacked[0].id; // Id of token contribution record
        let amountBacked = this.totalAmountBacked[0]["attributes"].totalBacked; // Money amount of alredy backed

        if (this.userId) {
            this._apiService.updateTokens(
                this.userId,
                this.userBalance,
                tokenAmount
            );
        } else {
            this._apiService
                .buyTokens(this.currentUserAddres, tokenAmount)
                .subscribe();
        }

        this._apiService
            .updateContributionToken(
                tokenContribId,
                amountBacked,
                tokenAmount,
                totalAvailable
            )
            .subscribe();
    }
    connectWallet = async () => {
        this.currentUserAddres = await this._walletService.initConnection();
        // this._apiService.insertWhitelistedAddress(this.currentUserAddres).subscribe();
    };
    checkConnectionAddress = async () => {
        if ((await this._walletService.getAddress()) === undefined) {
            this.currentUserAddres =
                await this._walletService.getCryptoComAddress();
        } else {
            this.currentUserAddres = await this._walletService.getAddress();
        }
    };
    checkwalletConnection = async () => {
        if ((await this._walletService.getAddress()) !== undefined) {
            this.isMetamask = true;
            this.isWalletConnect = false;
            this.isConnected = true;
        } else if (
            (await this._walletService.getCryptoComAddress()) !== undefined
        ) {
            this.isWalletConnect = true;
            this.isMetamask = false;
            this.isConnected = true;
        } else {
            this.isConnected = false;
        }
    };
    signTransaction = async () => {
        if (this.isMetamask && !this.isWalletConnect) {
            let txHash = await this._walletService.signTransactionsMetamask(
                this.currentUserAddres,
                ""
            );
            // console.log(txHash);
            // await listener.getTransaction(txHash);
        } else if (!this.isMetamask && this.isWalletConnect) {
            this._walletService.signTransactionsWalletConnect(
                this.currentUserAddres
            );
        }
    };
}
